// Generated by purs version 0.15.0
import * as Affjax from "../Affjax/index.js";
import * as Affjax_RequestBody from "../Affjax.RequestBody/index.js";
import * as Affjax_RequestHeader from "../Affjax.RequestHeader/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Array_NonEmpty_Serialized from "../Data.Array.NonEmpty.Serialized/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HTTP_Method from "../Data.HTTP.Method/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Index from "../Foreign.Index/index.js";
import * as Restaumatic_Order_Types from "../Restaumatic.Order.Types/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Restaumatic_Services_Delivery from "../Restaumatic.Services.Delivery/index.js";
import * as Restaumatic_TypesGen from "../Restaumatic.TypesGen/index.js";
import * as Utils_DataLoading from "../Utils.DataLoading/index.js";
var readDeliveryInfo = function (info) {
    return {
        restaurantId: info.restaurant_id,
        restaurantName: info.restaurant_name,
        restaurantSlug: info.restaurant_slug,
        path: info.path,
        deliveryCost: info.delivery_cost,
        freeThreshold: info.free_threshold,
        minOrderValue: info.min_order_value
    };
};
var readChangeRestaurant = function (info) {
    return {
        restaurantId: info.restaurant_id,
        restaurantName: info.restaurant_name,
        path: info.path,
        deliveryInfo: readDeliveryInfo(info)
    };
};
var fromRawDeliveryResponse = function (restaurantId) {
    return function (response) {
        var $3 = Data_Maybe.isNothing(restaurantId) || Data_Foldable.any(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function (info) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Restaurant_Types_Id.eqRestaurantId))(new Data_Maybe.Just(info.restaurant_id))(restaurantId);
        })(Data_Newtype.unwrap()(response.restaurants));
        if ($3) {
            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(new Restaumatic_Services_Delivery.Ok(Data_Functor.map(Data_Array_NonEmpty_Internal.functorNonEmptyArray)(readDeliveryInfo)(Data_Newtype.unwrap()(response.restaurants))));
        };
        return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(new Restaumatic_Services_Delivery.ChangeRestaurant(readChangeRestaurant(Data_Array_NonEmpty.head(Data_Newtype.unwrap()(response.restaurants)))));
    };
};
var fromRawResponse = function (restaurantId) {
    return function (f) {
        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.index(Foreign_Index.indexString(Data_Identity.monadIdentity))(f)("delivers"))(Foreign.readBoolean(Data_Identity.monadIdentity)))(function (delivers) {
            if (delivers) {
                return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Generic_Class.decode(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                    reflectSymbol: function () {
                        return "restaurants";
                    }
                })(Foreign_Generic_Class.decodeWithOptionsOther(Data_Array_NonEmpty_Serialized.decodeNonEmptyArray(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                    reflectSymbol: function () {
                        return "restaurant_slug";
                    }
                })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                    reflectSymbol: function () {
                        return "restaurant_name";
                    }
                })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                    reflectSymbol: function () {
                        return "restaurant_id";
                    }
                })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.decodeRestaurantId))())({
                    reflectSymbol: function () {
                        return "path";
                    }
                })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                    reflectSymbol: function () {
                        return "min_order_value";
                    }
                })(Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
                    reflectSymbol: function () {
                        return "free_threshold";
                    }
                })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Data_Money_Rounded.decodeMoney)))())({
                    reflectSymbol: function () {
                        return "delivery_cost";
                    }
                })(Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
                    reflectSymbol: function () {
                        return "delivers";
                    }
                })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))()))))()))(f))(fromRawDeliveryResponse(restaurantId));
            };
            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Restaumatic_Services_Delivery.WontDeliver.value);
        });
    };
};
var deliveryMethodToFormFields = /* #__PURE__ */ (function () {
    var delivery = function (type_) {
        return function (v) {
            return [ new Data_Tuple.Tuple("delivery_method", new Data_Maybe.Just(type_)), new Data_Tuple.Tuple("delivery_address[street]", new Data_Maybe.Just(v.address.street)), new Data_Tuple.Tuple("delivery_address[street_number]", new Data_Maybe.Just(v.address.streetNumber)), new Data_Tuple.Tuple("delivery_address[city]", new Data_Maybe.Just(v.address.city)), new Data_Tuple.Tuple("delivery_address[post_code]", new Data_Maybe.Just(v.address.postCode)), new Data_Tuple.Tuple("delivery_address[apt_number]", new Data_Maybe.Just(v.address.aptNumber)), new Data_Tuple.Tuple("delivery_address[floor]", new Data_Maybe.Just(v.address.floor)), new Data_Tuple.Tuple("delivery_address[country]", new Data_Maybe.Just(Data_Show.show(Restaumatic_TypesGen.showCountry)(v.address.country))), new Data_Tuple.Tuple("delivery_address[latitude]", new Data_Maybe.Just(Data_Show.show(Data_Show.showNumber)(v.location.latitude))), new Data_Tuple.Tuple("delivery_address[longitude]", new Data_Maybe.Just(Data_Show.show(Data_Show.showNumber)(v.location.longitude))) ];
        };
    };
    return function (v) {
        if (v instanceof Restaumatic_Order_Types.DeliveryMethodPickup) {
            return [ new Data_Tuple.Tuple("delivery_method", new Data_Maybe.Just("1")) ];
        };
        if (v instanceof Restaumatic_Order_Types.DeliveryMethodShipment) {
            return delivery("0")(v.value0);
        };
        if (v instanceof Restaumatic_Order_Types.DeliveryMethodNoContactDelivery) {
            return delivery("3")(v.value0);
        };
        if (v instanceof Restaumatic_Order_Types.DeliveryMethodDineIn) {
            return [ new Data_Tuple.Tuple("delivery_method", new Data_Maybe.Just("2")) ];
        };
        throw new Error("Failed pattern match at Restaumatic.Services.Delivery.Backend (line 63, column 3 - line 73, column 45): " + [ v.constructor.name ]);
    };
})();
var toRawRequest = function (req) {
    return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ new Data_Tuple.Tuple("restaurant_id", Data_Functor.map(Data_Maybe.functorMaybe)(Data_Show.show(Restaumatic_Restaurant_Types_Id.showRestaurantId))(req.restaurantId)) ])(deliveryMethodToFormFields(req.deliveryMethod));
};
var deliveryCost = function (config) {
    return function (request) {
        return Effect_Aff_Class.liftAff(Effect_Aff_Class.monadAffAff)(Utils_DataLoading.simpleRequest({
            method: new Data_Either.Left(Data_HTTP_Method.POST.value),
            url: config.urlPrefix + "/api/v1/delivery_cost",
            headers: [ new Affjax_RequestHeader.RequestHeader("Accept", "application/json") ],
            content: Data_Maybe.Just.create(Affjax_RequestBody.FormURLEncoded.create(toRawRequest(request))),
            username: Affjax.defaultRequest.username,
            password: Affjax.defaultRequest.password,
            withCredentials: Affjax.defaultRequest.withCredentials,
            responseFormat: Affjax.defaultRequest.responseFormat,
            timeout: Affjax.defaultRequest.timeout
        })(Control_Bind.composeKleisli(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Generic.decodeJSON(Foreign_Generic_Class.foreignDecode))(fromRawResponse(request.restaurantId))));
    };
};
var deliveryBackendWithConfig = function (config) {
    return {
        deliveryCost: deliveryCost(config)
    };
};
var defaultConfig = {
    urlPrefix: ""
};
var deliveryBackend = /* #__PURE__ */ deliveryBackendWithConfig(defaultConfig);
export {
    deliveryBackend,
    deliveryBackendWithConfig,
    defaultConfig
};
//# sourceMappingURL=index.js.map
